export default __webpack_public_path__ + "static/media/fuelEnDetailRompetrol.63fe169f.jpg";